var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContainerWithMenu',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"margin-bottom-20"},[_c('h1',{staticClass:"h2 margin-bottom-20"},[_vm._v("Eventi")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }